import { AxiosInstance } from 'axios'
import { createContext, createElement, ReactNode, useContext } from 'react'

const AxiosContext = createContext<AxiosInstance | null>(null)

export const useAxios = (): AxiosInstance => {
  const instance = useContext(AxiosContext)
  if (!instance) {
    throw new Error('useAxios must be used within an AxiosProvider')
  }
  return instance
}

export const AxiosProvider = ({ instance, children }: { instance: AxiosInstance; children: ReactNode }) => {
  return createElement(AxiosContext.Provider, { value: instance }, children)
}
